/* ==========================================================================
   Bureaustoelexpert – Theme JavaScript
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {

  // ─── Gallery: thumbnail → hoofdafbeelding ────────────────────────────────
  const thumbs      = document.querySelectorAll('.gallery-thumb');
  const slides      = document.querySelectorAll('.gallery-slide');

  function activateSlide(index) {
    slides.forEach((s, i) => s.classList.toggle('gallery-slide--active', i === index));
    thumbs.forEach((t, i) => t.classList.toggle('gallery-thumb--active', i === index));
    // Scroll de thumbnail zichtbaar in de thumbs-kolom
    if (thumbs[index]) {
      thumbs[index].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => activateSlide(i));
  });

  // ─── Gallery: touch swipe ────────────────────────────────────────────────
  const galleryMain = document.getElementById('gallery-main');
  if (galleryMain) {
    let touchStartX = 0;
    galleryMain.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
    galleryMain.addEventListener('touchend', e => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        const current = Array.from(slides).findIndex(s => s.classList.contains('gallery-slide--active'));
        const next = diff > 0
          ? Math.min(current + 1, slides.length - 1)
          : Math.max(current - 1, 0);
        activateSlide(next);
      }
    }, { passive: true });
  }

  // ─── Gallery: inzoomen op klik ───────────────────────────────────────────
  if (galleryMain) {
    // Maak lightbox-overlay aan
    const overlay = document.createElement('div');
    overlay.id = 'zoom-overlay';
    overlay.innerHTML = `
      <div id="zoom-overlay__backdrop"></div>
      <div id="zoom-overlay__stage">
        <button id="zoom-overlay__close" aria-label="Sluiten">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
        <button id="zoom-overlay__prev" aria-label="Vorige">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
        </button>
        <img id="zoom-overlay__img" src="" alt="">
        <button id="zoom-overlay__next" aria-label="Volgende">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="9 18 15 12 9 6"/>
          </svg>
        </button>
      </div>`;
    document.body.appendChild(overlay);

    const zoomImg    = document.getElementById('zoom-overlay__img');
    const zoomClose  = document.getElementById('zoom-overlay__close');
    const zoomPrev   = document.getElementById('zoom-overlay__prev');
    const zoomNext   = document.getElementById('zoom-overlay__next');
    const zoomBdrop  = document.getElementById('zoom-overlay__backdrop');

    // Verzamel alle afbeelding-URLs uit de slides (master resolutie via data-zoom)
    const imageUrls = Array.from(slides).map(s => {
      const img = s.querySelector('img');
      return img ? (img.dataset.zoom || img.src) : '';
    });

    let zoomIndex = 0;

    function openZoom(index) {
      zoomIndex = index;
      zoomImg.src = imageUrls[zoomIndex] || '';
      overlay.classList.add('zoom-overlay--open');
      document.body.style.overflow = 'hidden';
      updateZoomNav();
    }

    function closeZoom() {
      overlay.classList.remove('zoom-overlay--open');
      document.body.style.overflow = '';
    }

    function updateZoomNav() {
      if (zoomPrev) zoomPrev.style.display = zoomIndex > 0 ? '' : 'none';
      if (zoomNext) zoomNext.style.display = zoomIndex < imageUrls.length - 1 ? '' : 'none';
    }

    galleryMain.addEventListener('click', function () {
      const current = Array.from(slides).findIndex(s => s.classList.contains('gallery-slide--active'));
      openZoom(current >= 0 ? current : 0);
    });

    zoomClose.addEventListener('click', closeZoom);
    zoomBdrop.addEventListener('click', closeZoom);

    zoomPrev.addEventListener('click', function (e) {
      e.stopPropagation();
      if (zoomIndex > 0) { zoomIndex--; zoomImg.src = imageUrls[zoomIndex]; updateZoomNav(); }
    });

    zoomNext.addEventListener('click', function (e) {
      e.stopPropagation();
      if (zoomIndex < imageUrls.length - 1) { zoomIndex++; zoomImg.src = imageUrls[zoomIndex]; updateZoomNav(); }
    });

    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('zoom-overlay--open')) return;
      if (e.key === 'Escape') closeZoom();
      if (e.key === 'ArrowLeft'  && zoomIndex > 0)                    { zoomIndex--; zoomImg.src = imageUrls[zoomIndex]; updateZoomNav(); }
      if (e.key === 'ArrowRight' && zoomIndex < imageUrls.length - 1) { zoomIndex++; zoomImg.src = imageUrls[zoomIndex]; updateZoomNav(); }
    });
  }

  // ─── Hoeveelheid invoer ───────────────────────────────────────────────────
  const qtyField  = document.getElementById('quantity');
  const formQty   = document.getElementById('form-quantity');
  const btnMinus  = document.getElementById('qty-minus');
  const btnPlus   = document.getElementById('qty-plus');

  function updateQty(val) {
    if (!qtyField) return;
    const n = Math.max(1, Math.min(99, val));
    qtyField.value  = n;
    if (formQty) formQty.value = n;
  }

  if (btnMinus) btnMinus.addEventListener('click', () => updateQty(parseInt(qtyField.value) - 1));
  if (btnPlus)  btnPlus.addEventListener('click',  () => updateQty(parseInt(qtyField.value) + 1));
  if (qtyField) qtyField.addEventListener('change', () => updateQty(parseInt(qtyField.value)));

  // ─── Variant selector ────────────────────────────────────────────────────
  const variantBtns  = document.querySelectorAll('.variant-option');
  const variantInput = document.getElementById('variant-id');

  variantBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      const optionPos = this.dataset.option;
      const value     = this.dataset.value;

      // Update actieve knop in groep
      document.querySelectorAll(`.variant-option[data-option="${optionPos}"]`).forEach(b => {
        b.classList.remove('variant-option--active');
      });
      this.classList.add('variant-option--active');

      // Update geselecteerde tekst
      const groupLabel = this.closest('.variant-group').querySelector('.variant-group__label');
      if (groupLabel) {
        const selectedLabel = document.getElementById('selected-' + groupLabel.textContent.trim().toLowerCase().replace(/\s+/g, '-'));
        if (selectedLabel) selectedLabel.textContent = value;
      }

      // Variant ophalen en prijs + ID updaten
      matchVariant();
    });
  });

  function matchVariant() {
    const selectedOptions = [];
    [1, 2, 3].forEach(pos => {
      const activeBtn = document.querySelector(`.variant-option[data-option="${pos}"].variant-option--active`);
      if (activeBtn) selectedOptions.push(activeBtn.dataset.value);
    });

    if (window.productVariants) {
      const matched = window.productVariants.find(v => {
        return selectedOptions.every((opt, i) => v.options[i] === opt);
      });

      if (matched) {
        if (variantInput) variantInput.value = matched.id;
        updatePrice(matched);
        updateAvailability(matched.available);

        // ── Schakel naar de afbeelding die bij deze variant hoort ──────────
        if (matched.featured_image && matched.featured_image.id) {
          const targetSlide = Array.from(slides).findIndex(s =>
            String(s.dataset.imageId) === String(matched.featured_image.id)
          );
          if (targetSlide >= 0) activateSlide(targetSlide);
        }
      }
    }
  }

  function updatePrice(variant) {
    const priceEl    = document.getElementById('price-current');
    const origEl     = document.getElementById('price-original');
    const saveEl     = document.getElementById('price-save');
    if (!priceEl) return;

    priceEl.textContent = formatMoney(variant.price);

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (origEl) { origEl.textContent = formatMoney(variant.compare_at_price); origEl.style.display = ''; }
      if (saveEl) {
        const saving = variant.compare_at_price - variant.price;
        saveEl.textContent = 'Bespaar ' + formatMoney(saving);
        saveEl.style.display = '';
      }
    } else {
      if (origEl) origEl.style.display = 'none';
      if (saveEl) saveEl.style.display = 'none';
    }
  }

  function updateAvailability(available) {
    const addBtn = document.getElementById('add-to-cart-btn');
    const avail  = document.querySelector('.availability');
    if (addBtn) {
      addBtn.disabled  = !available;
      addBtn.innerHTML = available
        ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> In winkelwagen'
        : 'Uitverkocht';
    }
    if (avail) {
      avail.className = 'meta-item availability ' + (available ? 'availability--in' : 'availability--out');
      avail.innerHTML = available
        ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Op voorraad – levering in 1-3 werkdagen'
        : '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg> Tijdelijk uitverkocht';
    }
  }

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  // ─── Tab navigatie ────────────────────────────────────────────────────────
  const tabBtns   = document.querySelectorAll('.tab-btn');
  const tabPanels = document.querySelectorAll('.tab-panel');

  tabBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      const target = this.dataset.tab;

      tabBtns.forEach(b   => b.classList.remove('tab-btn--active'));
      tabPanels.forEach(p => p.classList.remove('tab-panel--active'));

      this.classList.add('tab-btn--active');
      const panel = document.getElementById('tab-' + target);
      if (panel) panel.classList.add('tab-panel--active');
    });
  });

  // ─── Add-to-cart AJAX ────────────────────────────────────────────────────
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      const addBtn = document.getElementById('add-to-cart-btn');
      const originalHTML = addBtn.innerHTML;

      addBtn.disabled   = true;
      addBtn.textContent = 'Toevoegen…';

      try {
        const formData = new FormData(productForm);
        // Sync quantity from qty-input to form
        if (qtyField) formData.set('quantity', qtyField.value);

        const response = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body:    formData
        });

        if (response.ok) {
          addBtn.innerHTML   = '✓ Toegevoegd!';
          addBtn.style.background = 'var(--color-success)';
          addBtn.style.borderColor = 'var(--color-success)';
          updateCartCount();

          setTimeout(() => {
            addBtn.innerHTML = originalHTML;
            addBtn.disabled  = false;
            addBtn.style.background = '';
            addBtn.style.borderColor = '';
          }, 2500);
        } else {
          const err = await response.json();
          addBtn.innerHTML = originalHTML;
          addBtn.disabled  = false;
          alert(err.description || 'Er is iets misgegaan. Probeer het opnieuw.');
        }
      } catch (err) {
        addBtn.innerHTML = originalHTML;
        addBtn.disabled  = false;
        console.error('Cart error:', err);
      }
    });
  }

  // ─── Quick-add knoppen (productkaarten) ──────────────────────────────────
  document.querySelectorAll('.product-card__quick-add').forEach(btn => {
    btn.addEventListener('click', async function () {
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      const originalText = this.textContent;
      this.disabled = true;
      this.textContent = '…';

      try {
        const response = await fetch('/cart/add.js', {
          method:  'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (response.ok) {
          this.textContent = '✓ Toegevoegd';
          updateCartCount();
          setTimeout(() => {
            this.textContent = originalText;
            this.disabled = false;
          }, 2000);
        } else {
          this.textContent = originalText;
          this.disabled = false;
        }
      } catch (e) {
        this.textContent = originalText;
        this.disabled = false;
      }
    });
  });

  async function updateCartCount() {
    try {
      const r    = await fetch('/cart.js');
      const cart = await r.json();
      const badge = document.querySelector('.cart-count');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    } catch (e) { /* stil falen */ }
  }

  // ─── "Lees reviews" → open reviews-tab en scroll ernaar ────────────────
  const gotoReviews = document.getElementById('goto-reviews');
  if (gotoReviews) {
    gotoReviews.addEventListener('click', function (e) {
      e.preventDefault();
      // Activeer de reviews-tab
      document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('tab-btn--active'));
      document.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('tab-panel--active'));
      const reviewsBtn   = document.querySelector('.tab-btn[data-tab="reviews"]');
      const reviewsPanel = document.getElementById('tab-reviews');
      if (reviewsBtn)   reviewsBtn.classList.add('tab-btn--active');
      if (reviewsPanel) reviewsPanel.classList.add('tab-panel--active');
      // Scroll naar de tabs
      const tabsSection = document.querySelector('.product-tabs-section');
      if (tabsSection) tabsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // ─── Meer reviews laden ─────────────────────────────────────────────────
  const loadMoreBtn = document.getElementById('load-more-reviews');
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function () {
      const hidden = document.querySelectorAll('.review-card--hidden');
      hidden.forEach(card => {
        card.classList.remove('review-card--hidden');
        card.classList.add('review-card--visible');
      });
      this.style.display = 'none';
    });
  }

  // ─── Schrijf een review knop → scroll naar formulier ─────────────────────
  const writeReviewBtn = document.getElementById('write-review-btn');
  if (writeReviewBtn) {
    writeReviewBtn.addEventListener('click', function () {
      const form = document.getElementById('review-form');
      if (form) {
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setTimeout(() => document.getElementById('review-name')?.focus(), 500);
      }
    });
  }

  // ─── Sterren picker in review formulier ──────────────────────────────────
  const starPicker = document.getElementById('star-picker');
  if (starPicker) {
    const stars = starPicker.querySelectorAll('.star-pick');
    const ratingInput = document.getElementById('review-rating-val');

    stars.forEach((star, i) => {
      star.addEventListener('mouseover', () => {
        stars.forEach((s, j) => s.classList.toggle('star-pick--active', j <= i));
      });
      star.addEventListener('mouseout', () => {
        const val = parseInt(ratingInput.value);
        stars.forEach((s, j) => s.classList.toggle('star-pick--active', j < val));
      });
      star.addEventListener('click', () => {
        ratingInput.value = i + 1;
        stars.forEach((s, j) => s.classList.toggle('star-pick--active', j <= i));
      });
    });
  }

  // ─── Review formulier indienen ────────────────────────────────────────────
  const reviewFormEl = document.getElementById('review-form-el');
  if (reviewFormEl) {
    reviewFormEl.addEventListener('submit', function (e) {
      e.preventDefault();
      reviewFormEl.style.display = 'none';
      document.getElementById('review-thanks').style.display = 'flex';
    });
  }

  // ─── Verlanglijst knop ────────────────────────────────────────────────────────
  const wishlistBtn = document.querySelector('.wishlist-btn');
  if (wishlistBtn) {
    wishlistBtn.addEventListener('click', function () {
      const svg = this.querySelector('svg path');
      if (svg) {
        const filled = this.dataset.wishlisted === 'true';
        svg.setAttribute('fill', filled ? 'none' : 'var(--color-error)');
        svg.setAttribute('stroke', filled ? 'currentColor' : 'var(--color-error)');
        this.dataset.wishlisted = filled ? 'false' : 'true';
      }
    });
  }

  // ─── Mobiel hamburger menu ────────────────────────────────────────────────
  const menuToggle = document.getElementById('menu-toggle');
  const headerNav  = document.querySelector('.header-nav');
  if (menuToggle && headerNav) {
    menuToggle.addEventListener('click', function () {
      const open = headerNav.classList.toggle('header-nav--open');
      this.setAttribute('aria-expanded', open);
    });
  }

});

